import { getRoot, Instance, SnapshotIn, types } from 'mobx-state-tree';
import { Point } from './GeoJSON';
import { OrganizationStats } from './OrganizationStats';
import { IRootStoreAny } from './rootUtilType';
import { callAgroApi } from '@services/agroapi';
import { FieldResponse } from '@services/responseTypes';
import { Transformers } from '@services/transformer';
export const Farm = types.model('Farm', {
  id: types.identifier,
  name: types.string,
  address: types.maybeNull(types.string),
  phone: types.maybeNull(types.string),
  location: types.maybeNull(types.late(() => Point)),
  stats: types.maybeNull(types.late(() => OrganizationStats))
}).views(self => ({
  get root() {
    return getRoot<IRootStoreAny>(self);
  }
})).actions(self => ({
  fetchFields(page = 1, {
    fieldName
  }: {
    fieldName: string;
  }) {
    return callAgroApi<FieldResponse[]>(`/farms/${self.id}/fields?include=stats&page=${page}&${fieldName ? `filter[query]=${fieldName}` : ''}`, 'GET').then(response => response.data.map(f => Transformers.field(f))).then(fields => {
      fields.map(field => self.root.uiStore.currentOrganization.pushToFields(field));
      return fields;
    });
  }
}));
export type IFarm = Instance<typeof Farm>;
export type IFarmSnapshotIn = SnapshotIn<typeof Farm>;